import React from 'react'
import { Typography } from '../../components/Typography'
import { TextContainer, Container, Content, IconContainer, Icon, FooterContainer, Footer } from './styles'
import { Header } from '../../components/Header'

export default function UnsubscribeSuccess() {
  return (
    <Container>
      {/* <Header/> */}
      <Content>
        <TextContainer>
          <Typography size="large" weight="bold" color="green" >Dados do atendimento enviados com sucesso!</Typography>
          <Typography>Sua colaboração ajuda muito com nossa qualidade de atendimento.</Typography>
        </TextContainer>
        <IconContainer>
          <Icon></Icon>
        </IconContainer>
      </Content>    
    </Container>
  )
}